var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-cards"},[_c('div',{staticClass:"row"},_vm._l((_vm.cards),function(card,key){return _c('div',{key:key,staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('b-card',{on:{"click":function($event){return _vm.openItem(card)}}},[_vm._v(_vm._s(card.title))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }